import React, { useEffect, useState } from 'react';
import { SectionItemConfig } from '../../types';
import { getStaticContent } from '../../api/assets';
import { componentCatalog } from '../../components';

interface SectionItemProps {
  config: SectionItemConfig;
}

export function SectionItem({ config }: SectionItemProps) {
  // If render is explicitly false, don't render anything
  if (config.render === false) {
    return null;
  }

  // If "file" is specified, load static HTML content
  if (config.file) {
    return <StaticContent file={config.file} />;
  }

  // If "component" is specified, resolve from catalog
  if (config.component) {
    const Component = componentCatalog[config.component];
    if (!Component) {
      console.warn(`Component "${config.component}" not found in catalog`);
      return (
        <div style={{ padding: '1rem', color: '#999', textAlign: 'center' }}>
          Component "{config.component}" not registered
        </div>
      );
    }
    return <Component variables={config.variables} name={config.name} />;
  }

  return null;
}

function StaticContent({ file }: { file: string }) {
  const [html, setHtml] = useState<string>('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getStaticContent(file)
      .then(setHtml)
      .catch((err) => {
        console.error(`Failed to load static content: ${file}`, err);
        setHtml(`<p>Failed to load content: ${file}</p>`);
      })
      .finally(() => setLoading(false));
  }, [file]);

  if (loading) return null;

  return <div dangerouslySetInnerHTML={{ __html: html }} />;
}
